import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import i18n from 'i18next';
import { Upload } from 'antd';
import { useTranslation } from "react-i18next";
import { pdfjs, Document, Page } from 'react-pdf';
import { Form, useParams } from "react-router-dom";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import useAdminApplicationDetailStore from "../../../store/useAdminApplicationDetailStore";
import useAuthAdminStore from "../../../store/useAuthAdminStore";
import useLoadingStore from "../../../store/useLoadingStore";
import useModalStore from "../../../store/useModalStore";
import Flex from "../../core/Flex";
import FormTitle from "../../form/FormTitle";
import FormText from "../../form/FormText";
import FormRemark from "../../form/FormRemark";
import FormButton from "../../form/FormButton";
import FormButtonPrimary from "../../form/FormButtonPrimary";
import Divider from "../../core/Divider";
import LoadingIcon from "../../core/LoadingIcon";
import ShadowBox from "../../core/ShadowBox";
import withErrorHandling from "../../../function/withErrorHandling";
import { apiDomain, basename, isProduction } from "../../../setting";
import feWriteLog from "../../../function/feWriteLog";
import PreviewPasswordPdf from './PreviewPasswordPdf/PreviewPasswordPdf'
import GlobalPDFErrorBoundary from "../../common/ErrorBoundary/GlobalPDFErrorBoundary";
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
// 1) Polyfill Promise.withResolvers
if (typeof Promise !== "undefined" && typeof Promise.withResolvers === "undefined") { 
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/js/pdf.worker.min.js`;

function Documents() {
  const { Dragger } = Upload;
  const { t } = useTranslation();
  const { aid } = useParams();
  const { isTaskListOpen, data, admGetPreAuthForm, suppattachmentForRedPoint, setSuppattachmentForRedPoint, documentRedPoint, setDocumentRedPoint, admDeleteAttachment, admNotedPreAuthForm, showSTPWarningModal } = useAdminApplicationDetailStore();
  const { token, logout, isCSTeam } = useAuthAdminStore();
  const { openModalInfo, openModalConfirm, closeModalConfirm } = useModalStore();
  const { setLoading } = useLoadingStore();

  const containerRef = useRef(null);
  const suppleUploadRef = useRef(null);
  const initialUploadRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);
  const [isUpdatingWidth, setIsUpdatingWidth] = useState(false);

  const [file, setFile] = useState({
    url: "",
    name: "",
    contenttype: ""
  });
  const [zoom, setZoom] = useState(1);
  const [zoomImg, setZoomImg] = useState(1);
  const [numPages, setNumPages] = useState();

  const loadAdmGetPreAuthForm = withErrorHandling(admGetPreAuthForm);
  const loadadmNotedPreAuthForm = withErrorHandling(admNotedPreAuthForm);
  const loadadmDeleteAttachment = withErrorHandling(admDeleteAttachment);
  const isImg = file.contenttype === "image/png" || file.contenttype === "image/jpeg" || file.contenttype === "image/gif";

  function zoomIn() {
    setZoom((prevZoom) => parseFloat((prevZoom + 0.1).toFixed(1)));
  }

  function zoomOut() {
    if (zoom > 0.1) {
      setZoom((prevZoom) => parseFloat((prevZoom - 0.1).toFixed(1)));
    }
  }

  function zoomInImg() {
    setZoomImg((prevZoomImg) => parseFloat((prevZoomImg + 0.1).toFixed(1)));
  }

  function zoomOutImg() {
    if (zoomImg > 0.1) {
      setZoomImg((prevZoomImg) => parseFloat((prevZoomImg - 0.1).toFixed(1)));
    }
  }

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleFileSelect = async (event, id) => {
    try {
      setLoading(true);
      const file = event.target.files[0];

      const allowedFileTypes = ['image/png', 'image/jpeg', 'application/pdf', 'image/gif', 'image/tiff', 'image/tif'];
      const isAllowedFileType = allowedFileTypes.includes(file.type);
      if (!isAllowedFileType) {
        setLoading(false);
        throw new Error('File Type Error');
      }

      const isFileSizeValid = file.size <= 20 * 1024 * 1024; // 20MB in bytes
      if (!isFileSizeValid) {
        setLoading(false);
        throw new Error('File Size Error');
      }

      // console.log("upload file", file, fileList)
      const formData = new FormData();
      formData.append('file', file);
      formData.append('attachid', id);
      formData.append('module', 'PREAUTH');

      const response_upload = await fetch(`${apiDomain}/${basename}/api/general/uploadFile`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData,
      });

      if (response_upload.status === 401) { // Unauthorized
        logout();
        setLoading(false);
        throw new Error('Unauthorized');
      }

      if (!response_upload.ok) {
        setLoading(false);
        throw new Error('Network Error');
      }

      loadAdmGetPreAuthForm(aid);

      event.target.value = '';

    } catch (error) {
      feWriteLog(`Error: ${error.message}`);
      if (error.message === "Unauthorized") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_expiry" : "pre_auth_uat_error_expiry",
          title: t("error:unauthorized.title"),
          text: t("error:unauthorized.message")
        });
        // setStep("loading");
      } else if (error.message === "Network Error") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_network" : "pre_auth_uat_error_network",
          title: t("error:network.title"),
          text: t("error:network.message")
        });
      } else if (error.message === "File Type Error") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_file_type" : "pre_auth_uat_error_file_type",
          title: t("error:fileFormat.title"),
          text: t("error:fileFormat.message")
        });
      } else if (error.message === "File Size Error") {
        openModalInfo({
          id: isProduction ? "pre_auth_error_file_size" : "pre_auth_uat_error_file_size",
          title: t("error:fileSize.title"),
          text: t("error:fileSize.message")
        });
      } else {
        openModalInfo({
          id: isProduction ? "pre_auth_error_unknown" : "pre_auth_uat_error_unknown",
          title: t("error:unknown.title"),
          text: t("error:unknown.message")
        });
      }

      event.target.value = '';

      return false;
    }
  };

  const updateWidth = () => {
    setIsUpdatingWidth(true);
    setTimeout(() => {
      if (containerRef.current && containerRef?.current?.offsetWidth) {
        const width = containerRef.current.offsetWidth - 34;
        setContainerWidth(width);
        setIsUpdatingWidth(false);
      }
    }, 300);
  };

  useEffect(() => {
    updateWidth();

    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [isTaskListOpen]);

  useEffect(() => {
    setZoom(1);
  }, [file?.url]);

  const Loading = () => {
    return (
      <Flex justifyContent={"center"} height={"100%"} width={"100%"} style={{ minHeight: 200 }}>
        <LoadingIcon>{t("translation:apply.loading.loading")}...</LoadingIcon>
      </Flex>
    );
  };

  return (
    <Flex ref={containerRef} direction={"column"} alignItems={"flex-start"} gap={16} height={"100%"} width={"100%"} style={{ overflow: "auto" }}>
      {
        file?.url ?
          <>
            {
              isUpdatingWidth ?
                <Loading />
                :
                <Flex width={containerWidth + 34} height={"100%"} direction={"column"} style={{ overflow: "hidden" }}>
                  <Flex width={"100%"} gap={8} justifyContent={"space-between"} style={{ zIndex: 10 }}>
                    <Flex>
                      <FormText>{file.name}</FormText>
                      <FormText>(zoom: {isImg ? zoomImg : zoom})</FormText>
                    </Flex>
                    <Flex>
                      <FormButton onClick={() => {
                        if (isImg) {
                          zoomOutImg();
                        } else {
                          zoomOut();
                        }
                      }}>
                        <Icon24 src={`${process.env.PUBLIC_URL}/images/circle-minus.png`} alt="zoom out" />
                      </FormButton>
                      <FormButton onClick={() => {
                        if (isImg) {
                          zoomInImg();
                        } else {
                          zoomIn();
                        }
                      }}>
                        <Icon24 src={`${process.env.PUBLIC_URL}/images/circle-plus.png`} alt="zoom in" />
                      </FormButton>
                      <FormButton onClick={() => {
                        setFile({
                          url: "",
                          name: "",
                          contenttype: ""
                        });
                      }}>
                        <Icon30 src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
                      </FormButton>
                    </Flex>
                  </Flex>
                  {
                    isImg ?
                      <Flex style={{ height: "calc(100% - 44px)", width: "inherit", overflow: "auto", alignItems: "flex-start" }}>
                        <img style={{
                          // width: `${zoomImg * 100}%`,
                          transform: `scale(${zoomImg})`,
                          transformOrigin: "top left",
                          transition: "width 0.25s ease-in-out",
                          objectFit: "cover",
                        }} src={file.url} alt={file.name} />
                      </Flex>
                      :
                      // <Document file={file} loading={<Loading />} className={"width100"} onLoadSuccess={onDocumentLoadSuccess}>
                      //   {Array.from(new Array(numPages), (el, index) => (
                      //     <Page
                      //       key={`page_${index + 1}`}
                      //       pageNumber={index + 1}
                      //       width={containerWidth}
                      //       scale={zoom}
                      //     />
                      //   ))}
                      // </Document> 
                      <GlobalPDFErrorBoundary>
                        <PreviewPasswordPdf
                          file={file}       // dataURL 或 URL
                           containerWidth={containerWidth}    // 宽度
                          zoom={1}                // 缩放比例
                        />
                      </GlobalPDFErrorBoundary>
                  }
                </Flex>
            }
          </>
          :
          <>
            <Flex width={"100%"} justifyContent={"space-between"}>
              <FormTitle>Supplementary Documents</FormTitle>
              <Flex>
                <input type="file" style={{ display: 'none' }} onChange={(event) => {
                  handleFileSelect(event, data?.form?.suppleattachid)
                }} ref={suppleUploadRef} />
                <ButtonWithIcon size={"small"} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => showSTPWarningModal(() => { suppleUploadRef.current.click() })} title={"Upload"}>
                  <Icon24 src={`${process.env.PUBLIC_URL}/images/plus.png`} alt="upload supplementary document" />
                  <span>Upload</span>
                </ButtonWithIcon>
              </Flex>
            </Flex>

            <Flex width={"100%"} direction={"column"} gap={8} style={{ padding: 5 }}>
              {
                suppattachmentForRedPoint.map((item, index) => {
                  return (
                    <ShadowBox style={{ justifyContent: 'space-between', position: 'relative' }} key={item.attachobjid} title={item.name}>
                      {
                        item.notifyadm > 0 && <PointRed />
                      }
                      <Flex gap={16}>
                        {
                          item.contenttype === "image/png" || item.contenttype === "image/jpeg" || item.contenttype === "image/gif" ?
                            <ImgAttachment src={item.url} alt={item.name} />
                            :
                            <ImgAttachment src={`${process.env.PUBLIC_URL}/images/attachment.png`} alt={item.name} />
                        }
                        <Flex direction={"column"} alignItems={"flex-start"} gap={0}>
                          <FormText>{item.name}</FormText>
                          <FormRemark>{item?.createdt?.replace("T", " ")}</FormRemark>
                        </Flex>
                      </Flex>
                      <Flex gap={8}>
                        <LinkBtn onClick={() => {
                          if (item.notifyadm > 0) {
                            setSuppattachmentForRedPoint(suppattachmentForRedPoint.map((item2) => {
                              if (item.attachobjid === item2.attachobjid) {
                                return {
                                  ...item2,
                                  notifyadm: 0
                                };
                              }
                              return item2;
                            }));
                            setDocumentRedPoint(documentRedPoint - 1);
                            loadadmNotedPreAuthForm(item.attachobjid);
                          }
                        }} href={item.orgUrl} target="_blank" rel="noopener noreferrer" download={item.name} title={`Download ${item.name}`}>Download</LinkBtn>
                        <LinkBtn
                          onClick={() => {
                            setFile({
                              url: item.orgUrl,
                              name: item.name,
                              contenttype: item.contenttype
                            });

                            setSuppattachmentForRedPoint(suppattachmentForRedPoint.map((item2) => {
                              if (item.attachobjid === item2.attachobjid) {
                                return {
                                  ...item2,
                                  notifyadm: 0
                                };
                              }
                              return item2;
                            }));
                            setDocumentRedPoint(documentRedPoint - 1);
                            loadadmNotedPreAuthForm(item.attachobjid);
                          }}
                          title={`View ${item.name}`}
                        >View</LinkBtn>

                        <DeleteBtn
                          title={`Delete ${item.name}`}
                          onClick={() => {

                            openModalConfirm({
                              title: t("translation:admin.request.tab.document"),
                              content: t("translation:admin.request.tab.document_delete", { key: item.name }),
                              modalConfirmPrimaryButtonStyleChangeToDanger: true,
                              callback: async () => {
                                await loadadmDeleteAttachment(item.attachobjid);
                                await loadAdmGetPreAuthForm(aid);
                              }
                            });
                          }}>
                          <Icon24 src={`${process.env.PUBLIC_URL}/images/bin.svg`} alt={`Delete ${item.name}`} />
                        </DeleteBtn>
                      </Flex>
                    </ShadowBox>
                  )
                })
              }
            </Flex>

            <Divider style={{ width: "100%" }} marginVertical={0} />


            <Flex width={"100%"} justifyContent={"space-between"}>
              <FormTitle>Initial Documents</FormTitle>
              <Flex>
                <input type="file" style={{ display: 'none' }} onChange={(event) => {
                  handleFileSelect(event, data?.form?.appattachid)
                }} ref={initialUploadRef} />
                {/* <ButtonWithIcon size={"small"} disabled={isCSTeam()} onClick={isCSTeam() ? null : () => showSTPWarningModal(() => { initialUploadRef.current.click() })} title={"Upload"}>
                  <Icon24 src={`${process.env.PUBLIC_URL}/images/plus.png`} alt="upload initial document" />
                  <span>Upload</span>
                </ButtonWithIcon> */}
              </Flex>
            </Flex>

            <Flex width={"100%"} direction={"column"} gap={8} style={{ padding: 5 }}>
              {
                data?.attachment?.map((item, index) => {
                  return (
                    <ShadowBox style={{ justifyContent: 'space-between' }} key={item.attachobjid} title={item.name}>
                      <Flex gap={16}>
                        {
                          item.contenttype === "image/png" || item.contenttype === "image/jpeg" || item.contenttype === "image/gif" ?
                            <ImgAttachment src={item.url} alt={item.name} />
                            :
                            <ImgAttachment src={`${process.env.PUBLIC_URL}/images/attachment.png`} alt={item.name} />
                        }
                        <Flex direction={"column"} alignItems={"flex-start"} gap={0}>
                          <FormText>{item.name}</FormText>
                          <FormRemark>{item?.createdt?.replace("T", " ")}</FormRemark>
                        </Flex>
                      </Flex>
                      <Flex gap={8}>
                        <LinkBtn onClick={() => {
                          if (item.notifyadm > 0) {
                            setSuppattachmentForRedPoint(suppattachmentForRedPoint.map((item2) => {
                              if (item.attachobjid === item2.attachobjid) {
                                return {
                                  ...item2,
                                  notifyadm: 0
                                };
                              }
                              return item2;
                            }));
                            setDocumentRedPoint(documentRedPoint - 1);
                            loadadmNotedPreAuthForm(item.attachobjid);
                          }
                        }} href={item.orgUrl} target="_blank" rel="noopener noreferrer" download={item.name} title={`Download ${item.name}`}>Download</LinkBtn>
                        <LinkBtn
                          onClick={() => {
                            setFile({
                              url: item.orgUrl,
                              name: item.name,
                              contenttype: item.contenttype
                            });

                            setSuppattachmentForRedPoint(suppattachmentForRedPoint.map((item2) => {
                              if (item.attachobjid === item2.attachobjid) {
                                return {
                                  ...item2,
                                  notifyadm: 0
                                };
                              }
                              return item2;
                            }));
                            setDocumentRedPoint(documentRedPoint - 1);
                            loadadmNotedPreAuthForm(item.attachobjid);
                          }}
                          title={`View ${item.name}`}
                        >View</LinkBtn>
                      </Flex>
                    </ShadowBox>
                  )
                })
              }
            </Flex>
          </>
      }
    </Flex >
  );
}

const ButtonWithIcon = styled(FormButtonPrimary)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 1px;
`;

const Icon24 = styled.img`
  width: 24px;
  height: 24px;
`;

const Icon30 = styled.img`
  width: 30px;
  height: 30px;
`;

const ImgAttachment = styled.img`
  width: 40px;
  height: 40px;
`;

const LinkBtn = styled.a`
  color: var(--aia-bx-blue-2);
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  font-size: 14px;

  &:hover {
    background-color: var(--aia-bx-blue-4);
  }
`;

const DeleteBtn = styled.a`
  display: flex;
  align-items: center;
  color: var(--aia-bx-blue-2);
  text-decoration: none;
  padding: 3.5px 16px;
  border-radius: 4px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  font-size: 14px;

  &:hover {
    background-color: var(--aia-bx-blue-4);
  }
`;

const PointRed = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--aia-bx-aiaRed-60);
  position: absolute;
  top: -3px;
  left: -3px;
`;

export default Documents;